<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 dark:text-gray-300 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength="255"
        />

        <input-rich-text
            name="address"
            label="Address"
            v-model="form.address"
            :language="form.language"
            :error="errors.address ? errors.address[0] : null"
            :maxlength="60000"
        />

        <input-text
            class="mt-3"
            name="characteristic_1"
            label="Characteristic 1"
            v-model="form.characteristic_1"
            :error="errors.characteristic_1 ? errors.characteristic_1[0] : null"
            :maxlength="255"
        />

        <media-reference
            :language="form.language"
            v-model="form.characteristic_1_icon"
            class="mt-3"
            label="Characteristic 1 Icon"
            :media-types="['Icon']"
            name="characteristic_1_icon_id"
            :error="errors.characteristic_1_icon_id ? errors.characteristic_1_icon_id[0] : null"
        />

        <input-text
            class="mt-3"
            name="characteristic_2"
            label="Characteristic 2"
            v-model="form.characteristic_2"
            :error="errors.characteristic_2 ? errors.characteristic_2[0] : null"
            :maxlength="255"
        />

        <media-reference
            :language="form.language"
            v-model="form.characteristic_2_icon"
            class="mt-3"
            label="Characteristic 2 Icon"
            :media-types="['Icon']"
            name="characteristic_2_icon_id"
            :error="errors.characteristic_2_icon_id ? errors.characteristic_2_icon_id[0] : null"
        />

        <input-text
            class="mt-3"
            name="characteristic_3"
            label="Characteristic 3"
            v-model="form.characteristic_3"
            :error="errors.characteristic_3 ? errors.characteristic_3[0] : null"
            :maxlength="255"
        />

        <media-reference
            :language="form.language"
            v-model="form.characteristic_3_icon"
            class="mt-3"
            label="Characteristic 3 Icon"
            :media-types="['Icon']"
            name="characteristic_3_icon_id"
            :error="errors.characteristic_3_icon_id ? errors.characteristic_3_icon_id[0] : null"
        />

        <media-reference
            :language="form.language"
            v-model="form.logo"
            class="mt-3"
            label="Logo"
            :media-types="['OperatorLogo']"
            name="logo_id"
            :error="errors.logo_id ? errors.logo_id[0] : null"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "LandBasedCasinoForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                name: this.getFormData("name"),
                address: this.getFormData("address"),
                characteristic_1: this.getFormData("characteristic_1"),
                characteristic_1_icon: this.getFormData("characteristic_one_icon"),
                characteristic_1_icon_id: this.getFormData("characteristic_1_icon_id"),
                characteristic_2: this.getFormData("characteristic_2"),
                characteristic_2_icon: this.getFormData("characteristic_two_icon"),
                characteristic_2_icon_id: this.getFormData("characteristic_2_icon_id"),
                characteristic_3: this.getFormData("characteristic_3"),
                characteristic_3_icon: this.getFormData("characteristic_three_icon"),
                characteristic_3_icon_id: this.getFormData("characteristic_3_icon_id"),
                logo: this.getFormData("logo"),
                logo_id: this.getFormData("logo_id"),
            },
        };
    },
    watch: {
        "form.logo": function(newValue){
            this.form.logo_id = newValue?.id || null
        },
        "form.characteristic_1_icon": function(newValue){
            this.form.characteristic_1_icon_id = newValue?.id || null
        },
        "form.characteristic_2_icon": function(newValue){
            this.form.characteristic_2_icon_id = newValue?.id || null
        },
        "form.characteristic_3_icon": function(newValue){
            this.form.characteristic_3_icon_id = newValue?.id || null
        },
    },
};
</script>
